import { useEffect, useState } from 'react';
import { setUrlValue, toFilters } from './utils';
export function useFilters(location, navigate, keys, options) {
    var _a;
    const [queryStringToRestore, setQueryStringToRestore] = useState();
    const [queryStringWasRestored, setQueryStringWasRestored] = useState(false);
    useEffect(() => {
        var _a;
        if (((_a = options) === null || _a === void 0 ? void 0 : _a.persistenceKey) && queryStringWasRestored) {
            localStorage.setItem(options.persistenceKey, location.search);
        }
    }, [location.search]);
    useEffect(() => {
        if (queryStringToRestore != null && !queryStringWasRestored) {
            setUrlValue(location, navigate, queryStringToRestore);
            setQueryStringWasRestored(true);
        }
    }, [queryStringToRestore]);
    const locationSearch = ((_a = options) === null || _a === void 0 ? void 0 : _a.persistenceKey) && !location.search.includes('=')
        ? localStorage.getItem(options.persistenceKey) || ''
        : location.search;
    const urlSearchParams = new URLSearchParams(locationSearch);
    if (queryStringToRestore == null) {
        setQueryStringToRestore(urlSearchParams.toString());
    }
    return toFilters(location, navigate, keys, urlSearchParams);
}
//# sourceMappingURL=use-filters.js.map